var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

import { OBJECT_TYPE } from './platform-object';
import { IntegrationMetaKey } from './integration-meta';
export let CHANNEL_TYPES = /*#__PURE__*/function (CHANNEL_TYPES) {
  CHANNEL_TYPES["DOORDASH"] = "DOORDASH";
  CHANNEL_TYPES["GOOGLE_ADS"] = "GOOGLE_ADS";
  CHANNEL_TYPES["GOOGLE_SHOPPING"] = "GOOGLE_SHOPPING";
  CHANNEL_TYPES["GOOGLE_LOCAL_LISTINGS"] = "GOOGLE_LOCAL_LISTINGS";
  CHANNEL_TYPES["META_COMMERCE"] = "META_COMMERCE";
  CHANNEL_TYPES["GOOGLE_MY_BUSINESS"] = "GOOGLE_MY_BUSINESS";
  CHANNEL_TYPES["TIKTOK"] = "TIKTOK";
  CHANNEL_TYPES["SQ_CONNECT"] = "SQ_CONNECT";
  CHANNEL_TYPES["SQ_ONLINE"] = "SQ_ONLINE";
  CHANNEL_TYPES["KIOSK"] = "KIOSK";
  CHANNEL_TYPES["UBER_EATS"] = "UBER_EATS";
  return CHANNEL_TYPES;
}({});
export const CHANNEL_TYPE_MAP = {
  DOORDASH: {
    SVG_COMPONENT: 'svg/doordash',
    NAME_I8N: 'onlineChannels.doordash.name',
    LABEL_I18N: 'onlineChannels.doordash.name'
  },
  GOOGLE_ADS: {
    SVG_COMPONENT: 'svg/google-ads',
    NAME_I8N: 'onlineChannels.googleAds.name',
    LABEL_I18N: 'onlineChannels.googleAds.name'
  },
  GOOGLE_SHOPPING: {
    SVG_COMPONENT: 'svg/google-free-product-listings-icon',
    NAME_I8N: 'onlineChannels.googleFreeProductListings.shortName',
    LABEL_I18N: 'onlineChannels.googleFreeProductListings.name'
  },
  GOOGLE_LOCAL_LISTINGS: {
    SVG_COMPONENT: 'svg/google-free-local-product-listings-icon',
    NAME_I8N: 'onlineChannels.googleLocalInventory.shortName',
    LABEL_I18N: 'onlineChannels.googleLocalInventory.name'
  },
  META_COMMERCE: {
    SVG_COMPONENT: 'svg/meta-commerce',
    NAME_I8N: 'onlineChannels.metaCommerce.shortName',
    LABEL_I18N: 'onlineChannels.metaCommerce.name'
  },
  SQ_ONLINE: {
    SVG_COMPONENT: 'svg/square-online-icon',
    NAME_I8N: 'common.translationTypes.ORDER_SOURCE_ONLINE_STORE',
    LABEL_I18N: 'common.translationTypes.ORDER_SOURCE_ONLINE_STORE'
  },
  GOOGLE_MY_BUSINESS: {
    SVG_COMPONENT: 'svg/google-my-business',
    NAME_I8N: 'onlineChannels.googleMyBusiness.shortName',
    LABEL_I18N: 'onlineChannels.googleMyBusiness.shortName'
  },
  KIOSK: {
    SVG_COMPONENT: 'svgs/market/kiosk',
    NAME_I8N: 'onlineChannels.kiosk.name',
    LABEL_I18N: 'onlineChannels.kiosk.name'
  }
};
export let ChannelAuthStatus = /*#__PURE__*/function (ChannelAuthStatus) {
  ChannelAuthStatus["ONBOARDING"] = "ONBOARDING";
  ChannelAuthStatus["ACTIVE"] = "ACTIVE";
  ChannelAuthStatus["CLAIM_COLLISION"] = "CLAIM_COLLISION";
  ChannelAuthStatus["PENDING"] = "PENDING";
  ChannelAuthStatus["ERROR"] = "ERROR";
  ChannelAuthStatus["SETUP"] = "SETUP";
  return ChannelAuthStatus;
}({});
export let ChannelAcknowledgmentStatus = /*#__PURE__*/function (ChannelAcknowledgmentStatus) {
  ChannelAcknowledgmentStatus["ERROR"] = "ERROR";
  ChannelAcknowledgmentStatus["SUCCESS"] = "SUCCESS";
  ChannelAcknowledgmentStatus["PENDING"] = "PENDING";
  return ChannelAcknowledgmentStatus;
}({});
export let CHANNEL_STATUS = /*#__PURE__*/function (CHANNEL_STATUS) {
  CHANNEL_STATUS["SETUP"] = "SETUP";
  CHANNEL_STATUS["ONBOARDING"] = "ONBOARDING";
  CHANNEL_STATUS["ACTIVE"] = "ACTIVE";
  CHANNEL_STATUS["INACTIVE"] = "INACTIVE";
  CHANNEL_STATUS["CLAIM_COLLISION"] = "CLAIM_COLLISION";
  CHANNEL_STATUS["DISABLED"] = "DISABLED";
  CHANNEL_STATUS["ERROR"] = "ERROR";
  CHANNEL_STATUS["PROCESSING_REMOVAL"] = "PROCESSING_REMOVAL";
  CHANNEL_STATUS["PENDING_PUBLISHING"] = "PENDING_PUBLISHING";
  return CHANNEL_STATUS;
}({});

// TODO: [can] move this enum to channel-meta.ts file as its more relevant to that file
export let CHANNEL_META_KEYS = /*#__PURE__*/function (CHANNEL_META_KEYS) {
  CHANNEL_META_KEYS["DOORDASH_SETUP"] = "DOORDASH_SETUP";
  CHANNEL_META_KEYS["GOOGLE_ADS_SETUP"] = "GOOGLE_ADS_SETUP";
  CHANNEL_META_KEYS["GOOGLE_ACCOUNT_INFO"] = "GOOGLE_ACCOUNT_INFO";
  CHANNEL_META_KEYS["SQUARE_ONLINE_SITES"] = "SQUARE_ONLINE_SITES";
  CHANNEL_META_KEYS["SQ_CONNECT_RESCOPE_REQUEST"] = "SQ_CONNECT_RESCOPE_REQUEST";
  CHANNEL_META_KEYS["FACEBOOK_PAGE_LOCATION_MAPPINGS"] = "FACEBOOK_PAGE_LOCATION_MAPPINGS";
  CHANNEL_META_KEYS["GMB_ACCOUNT_INFO"] = "GMB_ACCOUNT_INFO";
  CHANNEL_META_KEYS["GOOGLE_LOCAL_LISTINGS_ACCOUNT_INFO"] = "GOOGLE_LOCAL_LISTINGS_ACCOUNT_INFO";
  CHANNEL_META_KEYS["CLAIM_RESOLUTION_MERCHANT_ACCOUNT"] = "CLAIM_RESOLUTION_MERCHANT_ACCOUNT";
  CHANNEL_META_KEYS["META_COMMERCE_SETUP"] = "META_COMMERCE_SETUP";
  CHANNEL_META_KEYS["META_COMMERCE_PRE_CHECK_ELIGIBILITY"] = "META_COMMERCE_PRE_CHECK_ELIGIBILITY";
  return CHANNEL_META_KEYS;
}({});
export let ChannelErrorType = /*#__PURE__*/function (ChannelErrorType) {
  ChannelErrorType["GOOGLE_ADS_AUTHENTICATION_ERROR"] = "GOOGLE_ADS_ERROR";
  ChannelErrorType["GOOGLE_ADS_INSUFFICIENT_SCOPES_ERROR"] = "GOOGLE_ADS_INSUFFICIENT_SCOPES_ERROR";
  ChannelErrorType["GOOGLE_AUTHENTICATION_ERROR"] = "GOOGLE_AUTHENTICATION_ERROR";
  ChannelErrorType["GOOGLE_CONTENT_AUTHENTICATION_ERROR"] = "GOOGLE_CONTENT_AUTHENTICATION_ERROR";
  ChannelErrorType["GOOGLE_MY_BUSINESS_INSUFFICIENT_SCOPES_ERROR"] = "GOOGLE_MY_BUSINESS_INSUFFICIENT_SCOPES_ERROR";
  ChannelErrorType["GOOGLE_CONTENT_INSUFFICIENT_SCOPES_ERROR"] = "GOOGLE_CONTENT_INSUFFICIENT_SCOPES_ERROR";
  ChannelErrorType["GOOGLE_RE_AUTHENTICATION_ERROR"] = "GOOGLE_RE_AUTHENTICATION_ERROR";
  ChannelErrorType["GOOGLE_SITE_URL_MISMATCH_ERROR"] = "GOOGLE_SITE_URL_MISMATCH_ERROR";
  ChannelErrorType["GMB_AUTHENTICATION_ERROR"] = "GMB_AUTHENTICATION_ERROR";
  ChannelErrorType["META_COMMERCE_AUTH_ERROR"] = "META_COMMERCE_AUTH_ERROR";
  ChannelErrorType["META_COMMERCE_URL_MISMATCH_ERROR"] = "META_COMMERCE_URL_MISMATCH_ERROR";
  ChannelErrorType["UNPUBLISHED_SQUARE_ONLINE_SITE_ERROR"] = "UNPUBLISHED_SQUARE_ONLINE_SITE_ERROR";
  return ChannelErrorType;
}({});
// Marketing channels (we do catalog syncing)
export const ONLINE_MARKETING_CHANNEL_TYPES = [CHANNEL_TYPES.GOOGLE_SHOPPING, CHANNEL_TYPES.GOOGLE_LOCAL_LISTINGS, CHANNEL_TYPES.META_COMMERCE];

// Channels with onboarding flows
export const INTEGRATION_CHANNEL_TYPES = [CHANNEL_TYPES.DOORDASH, CHANNEL_TYPES.GOOGLE_ADS, CHANNEL_TYPES.GOOGLE_SHOPPING, CHANNEL_TYPES.GOOGLE_LOCAL_LISTINGS, CHANNEL_TYPES.GOOGLE_MY_BUSINESS, CHANNEL_TYPES.META_COMMERCE];
export const ALLOWED_STORE_NAME_CHANNEL_TYPES = [CHANNEL_TYPES.GOOGLE_SHOPPING, CHANNEL_TYPES.META_COMMERCE];
let Channel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('number'), _dec7 = attr('string'), _dec8 = attr('json-or-value'), _dec9 = attr('date'), _dec10 = attr('date'), _dec11 = attr('date'), _dec12 = hasMany('channels/channel-meta'), _dec13 = hasMany('channels/account-issue'), _dec14 = belongsTo('channels/integration', {
  async: false
}), _dec15 = attr(), _dec16 = computed('authStatus'), _dec17 = computed('errorDescriptions.errors'), _dec18 = computed('channelType', 'googleAccountInfoValue.website_url', 'googleWebsiteUrl'), _dec19 = computed('channelMetas.@each.value', 'errorDescriptions.errors'), _dec20 = computed('errorDescriptions.errors'), _dec21 = computed('accountIssues.[]', 'criticalAccountIssues.length'), _dec22 = computed('status'), _dec23 = computed('status'), _dec24 = computed('status'), _dec25 = computed('status'), _dec26 = computed('status'), _dec27 = computed('status'), _dec28 = computed('status'), _dec29 = computed('channelType'), _dec30 = computed('channelType'), _dec31 = computed('channelType'), _dec32 = computed('googleMerchantCenterAccountInfoIntegrationMetaValue.merchant_center_account_id'), _dec33 = computed('googleMerchantCenterAccountInfoIntegrationMetaValue.account_users'), _dec34 = computed('hasGoogleMerchantCenterAccountInfoIntegrationMetaValue', 'integration.integrationMetas.@each.value'), _dec35 = computed('googleMerchantCenterAccountInfoIntegrationMetaValue.website_url'), _dec36 = computed('accountIssues.@each.title'), _dec37 = computed('accountIssues.@each.code'), _dec38 = computed('accountIssues.@each.severity'), _dec39 = computed('accountIssues.@each.isErrorSeverity'), (_class = class Channel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "primitiveId", _descriptor, this);
    _initializerDefineProperty(this, "merchantId", _descriptor2, this);
    _initializerDefineProperty(this, "channelType", _descriptor3, this);
    _initializerDefineProperty(this, "status", _descriptor4, this);
    _initializerDefineProperty(this, "authStatus", _descriptor5, this);
    _initializerDefineProperty(this, "version", _descriptor6, this);
    _initializerDefineProperty(this, "acknowledgmentStatus", _descriptor7, this);
    _initializerDefineProperty(this, "errorDescriptions", _descriptor8, this);
    _initializerDefineProperty(this, "createdAt", _descriptor9, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor10, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor11, this);
    _initializerDefineProperty(this, "channelMetas", _descriptor12, this);
    _initializerDefineProperty(this, "accountIssues", _descriptor13, this);
    _initializerDefineProperty(this, "integration", _descriptor14, this);
    _initializerDefineProperty(this, "counts", _descriptor15, this);
  }
  async enable() {
    const adapter = this.store.adapterFor('channels/channel');
    const updatedChannel = await adapter.enable(this);
    this.store.pushPayload('channels/channel', updatedChannel);
  }
  async updateCounts() {
    this.counts = await this.store.queryRecord('channels/platform-objects/count', {
      channel_ids: this.id,
      object_type: OBJECT_TYPE.ITEM_VARIATION
    }).catch();
  }
  get isAuthStatusPending() {
    return this.authStatus === ChannelAuthStatus.PENDING;
  }
  get hasErrors() {
    const errors = this.errorDescriptions?.errors;
    if (!errors) {
      return false;
    }
    return errors.length > 0;
  }
  get websiteUrl() {
    const isAllowedStoreName = ALLOWED_STORE_NAME_CHANNEL_TYPES.includes(this.channelType);
    if (!isAllowedStoreName) {
      return '';
    }
    switch (this.channelType) {
      case CHANNEL_TYPES.GOOGLE_SHOPPING:
        return this.googleWebsiteUrl || '';
      default:
        return '';
    }
  }
  get hasUnpublishedSquareOnlineSiteError() {
    const errors = this.errorDescriptions?.errors;
    if (!errors) {
      return false;
    }
    return errors.some(err => err.type === ChannelErrorType.UNPUBLISHED_SQUARE_ONLINE_SITE_ERROR);
  }
  get hasAuthenticationError() {
    const errors = this.errorDescriptions?.errors;
    if (!errors) {
      return false;
    }
    return errors.some(error => {
      return [ChannelErrorType.GOOGLE_AUTHENTICATION_ERROR, ChannelErrorType.GOOGLE_CONTENT_AUTHENTICATION_ERROR, ChannelErrorType.GOOGLE_RE_AUTHENTICATION_ERROR, ChannelErrorType.GOOGLE_ADS_AUTHENTICATION_ERROR, ChannelErrorType.GMB_AUTHENTICATION_ERROR, ChannelErrorType.META_COMMERCE_AUTH_ERROR].includes(error.type);
    });
  }
  get hasCriticalAccountLevelIssues() {
    return this.criticalAccountIssues.length > 0;
  }
  get squareOnlineSitesMeta() {
    const foundChannelMeta = this.channelMetas.findBy('key', CHANNEL_META_KEYS.SQUARE_ONLINE_SITES);
    return foundChannelMeta || null;
  }
  get squareOnlineSites() {
    const squareOnlineSitesMetaValue = this.squareOnlineSitesMeta?.value;
    if (!squareOnlineSitesMetaValue) {
      return [];
    }
    return squareOnlineSitesMetaValue.sites;
  }
  get isStatusOnboarding() {
    return this.status === CHANNEL_STATUS.ONBOARDING;
  }
  get isStatusSetup() {
    return this.status === CHANNEL_STATUS.SETUP;
  }
  get isStatusPending() {
    return this.status === CHANNEL_STATUS.PENDING_PUBLISHING;
  }
  get isStatusProcessingRemoval() {
    return this.status === CHANNEL_STATUS.PROCESSING_REMOVAL;
  }
  get isStatusClaimCollision() {
    return this.status === CHANNEL_STATUS.CLAIM_COLLISION;
  }
  get isIntegrated() {
    const integratedStatuses = [CHANNEL_STATUS.ACTIVE, CHANNEL_STATUS.DISABLED, CHANNEL_STATUS.ERROR, CHANNEL_STATUS.PENDING_PUBLISHING];
    return integratedStatuses.includes(this.status);
  }
  get isIntegratedAndPublished() {
    const integratedAndPublishedStatuses = [CHANNEL_STATUS.ACTIVE, CHANNEL_STATUS.DISABLED, CHANNEL_STATUS.ERROR];
    return integratedAndPublishedStatuses.includes(this.status);
  }
  get svgComponentName() {
    if (!INTEGRATION_CHANNEL_TYPES.includes(this.channelType)) {
      return '';
    }
    return CHANNEL_TYPE_MAP[this.channelType]?.SVG_COMPONENT || '';
  }
  get nameI18n() {
    if (!INTEGRATION_CHANNEL_TYPES.includes(this.channelType)) {
      return '';
    }
    return CHANNEL_TYPE_MAP[this.channelType]?.NAME_I8N || '';
  }
  get labelI18N() {
    if (!ONLINE_MARKETING_CHANNEL_TYPES.includes(this.channelType)) {
      return '';
    }
    return CHANNEL_TYPE_MAP[this.channelType]?.LABEL_I18N || '';
  }
  get googleMerchantCenterAccountId() {
    return this.googleMerchantCenterAccountInfoIntegrationMetaValue?.merchant_center_account_id ?? null;
  }
  get googleAccountUsers() {
    return this.googleMerchantCenterAccountInfoIntegrationMetaValue?.account_users ?? [];
  }
  hasGoogleMerchantCenterAccountInfoIntegrationMetaValue(integrationMeta) {
    return integrationMeta.key === IntegrationMetaKey.GOOGLE_MERCHANT_CENTER_ACCOUNT_INFO;
  }
  get googleMerchantCenterAccountInfoIntegrationMetaValue() {
    const googleMerchantCenterAccountInfo = this.integration?.integrationMetas.find(this.hasGoogleMerchantCenterAccountInfoIntegrationMetaValue);
    if (!googleMerchantCenterAccountInfo) {
      return null;
    }
    if (typeof googleMerchantCenterAccountInfo.value === 'string') {
      return null;
    }
    return googleMerchantCenterAccountInfo.value;
  }
  get googleWebsiteUrl() {
    return this.googleMerchantCenterAccountInfoIntegrationMetaValue?.website_url ?? null;
  }
  get hasGoogleShippingOrTaxAccountIssue() {
    const SHIPPING_ERROR = '[shipping]';
    const TAX_ERROR = '[tax]';
    return this.accountIssues.any(accountIssues => {
      return accountIssues.title.includes(SHIPPING_ERROR) || accountIssues.title.includes(TAX_ERROR);
    });
  }
  get hasGoogleReturnPolicyIssue() {
    const CODE = 'misrepresentation_of_self_or_products_missing_refund_policy_policy';
    return this.accountIssues.any(accountIssues => accountIssues.code.includes(CODE));
  }
  get criticalAccountIssues() {
    return this.accountIssues.filter(accountIssue => accountIssue.isCritical);
  }
  get errorAccountIssues() {
    return this.accountIssues.filter(accountIssue => accountIssue.isErrorSeverity);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "primitiveId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "channelType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "authStatus", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "acknowledgmentStatus", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "errorDescriptions", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "channelMetas", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "accountIssues", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "integration", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "counts", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isAuthStatusPending", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "isAuthStatusPending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasErrors", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "hasErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "websiteUrl", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "websiteUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUnpublishedSquareOnlineSiteError", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "hasUnpublishedSquareOnlineSiteError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasAuthenticationError", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "hasAuthenticationError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCriticalAccountLevelIssues", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "hasCriticalAccountLevelIssues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusOnboarding", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusOnboarding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusSetup", [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusSetup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusPending", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusPending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusProcessingRemoval", [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusProcessingRemoval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isStatusClaimCollision", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "isStatusClaimCollision"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isIntegrated", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "isIntegrated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isIntegratedAndPublished", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "isIntegratedAndPublished"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "svgComponentName", [_dec29], Object.getOwnPropertyDescriptor(_class.prototype, "svgComponentName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameI18n", [_dec30], Object.getOwnPropertyDescriptor(_class.prototype, "nameI18n"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "labelI18N", [_dec31], Object.getOwnPropertyDescriptor(_class.prototype, "labelI18N"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googleMerchantCenterAccountId", [_dec32], Object.getOwnPropertyDescriptor(_class.prototype, "googleMerchantCenterAccountId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googleAccountUsers", [_dec33], Object.getOwnPropertyDescriptor(_class.prototype, "googleAccountUsers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googleMerchantCenterAccountInfoIntegrationMetaValue", [_dec34], Object.getOwnPropertyDescriptor(_class.prototype, "googleMerchantCenterAccountInfoIntegrationMetaValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "googleWebsiteUrl", [_dec35], Object.getOwnPropertyDescriptor(_class.prototype, "googleWebsiteUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasGoogleShippingOrTaxAccountIssue", [_dec36], Object.getOwnPropertyDescriptor(_class.prototype, "hasGoogleShippingOrTaxAccountIssue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasGoogleReturnPolicyIssue", [_dec37], Object.getOwnPropertyDescriptor(_class.prototype, "hasGoogleReturnPolicyIssue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "criticalAccountIssues", [_dec38], Object.getOwnPropertyDescriptor(_class.prototype, "criticalAccountIssues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorAccountIssues", [_dec39], Object.getOwnPropertyDescriptor(_class.prototype, "errorAccountIssues"), _class.prototype)), _class));
export { Channel as default };